import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'semantic-ui-react';
import MonitorTableRow from 'app/ui/pages/monitor/monitorTableBody/monitorTableRow/MonitorTableRow';

function MonitorTableBody(props) {
  const { patients = [], account } = props;
  return (
    <Table.Body>
      {patients.map(patient => {
        return <MonitorTableRow 
          key={patient.id} 
          row={patient} 
          account={account} />;
      })}
    </Table.Body>
  )
}

MonitorTableBody.propTypes = {
  patients: PropTypes.array,
  account: PropTypes.object
}

export default MonitorTableBody
